import { styled } from "styled-components";

export const DeliveryContainerBox = styled.div`
  border: 1px solid #383838;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;
  > div {
    flex: 1;
  }
`;
